import { BasicPermissionItem } from '../../PermissionItem'
import { Simple } from '../../common'
import { ProjectSettings } from '../../../cimsPage/instances/admin'

const object = 'Project Settings'
const plural = 'project settings'
const page = ProjectSettings

export const EditProjectSettings = new BasicPermissionItem({
  id: 'ACA30F63-BA78-48E1-8902-56E4D4632326',
  page,
  name: `Edit ${object}`,
  action: `edit general ${plural}`,
})

export const ViewProjectSettings = Simple({
  id: '495214C1-072C-40B5-AD8A-68C71D11CD7C',
  page,
  object,
  plural,
  action: 'View',
})

export const EditSharePointSettings = new BasicPermissionItem({
  id: '8B7E7F2F-4770-45C6-99E4-598FCD62295C',
  page,
  name: 'Edit SharePoint Settings',
  action: 'edit SharePoint connection settings',
  allowMixedCase: true,
})

export const EditWorkflowSettings = new BasicPermissionItem({
  id: '879D203F-1B47-443F-8D07-1C532BEC7AF5',
  page,
  name: 'Edit Workflow Settings',
  action: 'edit workflow settings',
})

export type SettingsPermission =
  | typeof EditProjectSettings
  | typeof ViewProjectSettings
  | typeof EditSharePointSettings
  | typeof EditWorkflowSettings
